export default {"src":"/_next/static/media/02_LuckySpin_PT.ac9b4db1.gif","height":261,"width":267};